export const getSafeHttpUrl = (
  value: unknown,
  baseUrl: string
): string | null => {
  if (typeof value !== 'string' || value.length === 0) return null;
  if (!/^https?:\/\//i.test(value) && !value.startsWith('/')) return null;

  try {
    const url = new URL(value, baseUrl);
    return ['http:', 'https:'].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
};
